import createAction from '@clearscore/helpers.create-action';
import createRequestPayload from '@clearscore/helpers.create-request-payload';

import { NOVA_USER_FETCH, NOVA_USER_SAVE } from './nova-user.types';

export const fetch = () => createAction(NOVA_USER_FETCH, createRequestPayload('customerOps', '/v1/user-info'));

export const save = (data) =>
    createAction(NOVA_USER_SAVE, createRequestPayload('customerOps', '/v1/user-info', 'post', data));
